var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1000" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("refresh")]),
              _vm._v(" Reprogramación de vacaciones\n        "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.agregarReprogramacion(
                    _vm.form.fecha_desde_rep,
                    _vm.form.fecha_hasta_rep,
                    _vm.total_dias_solicitados
                  )
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "py-0 px-3",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c("p", { staticClass: "texto" }, [
                        _c("b", { staticClass: "texto" }, [
                          _vm._v("Fecha desde: ")
                        ]),
                        _vm._v(
                          _vm._s(this.form.fecha_desde) + "\n              "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", { staticClass: "texto" }, [
                          _vm._v("Fecha hasta: ")
                        ]),
                        _vm._v(_vm._s(this.form.fecha_hasta)),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", { staticClass: "texto" }, [
                          _vm._v("Días para reprogramar: ")
                        ]),
                        _vm._v(_vm._s(this.form.total_dias)),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("b", [_vm._v("Datos de la reprogramación: ")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  items: _vm.motivos_reprogramacion,
                                  "item-value": "valor",
                                  "item-text": "valor",
                                  label: "Motivo de la reprogramación",
                                  maxlength: "150",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.motivo_reprogramacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "motivo_reprogramacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.motivo_reprogramacion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _vm.form.motivo_reprogramacion == "Otros"
                                ? _c("v-textarea", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      rows: "1",
                                      label:
                                        "Justificación de la reprogramación",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      "auto-grow": ""
                                    },
                                    model: {
                                      value:
                                        _vm.form.justificacion_reprogramacion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "justificacion_reprogramacion",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.justificacion_reprogramacion"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { wrap: "" } }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ingrese la fecha de su reprogramación: ")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha inicio",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde_rep", $$v)
                                  },
                                  expression: "form.fecha_desde_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha fin",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta_rep", $$v)
                                  },
                                  expression: "form.fecha_hasta_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _vm.form.fecha_desde_rep &&
                              _vm.form.fecha_hasta_rep
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Días",
                                      disabled: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.total_dias_solicitados,
                                      callback: function($$v) {
                                        _vm.total_dias_solicitados = $$v
                                      },
                                      expression: "total_dias_solicitados"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    block: "",
                                    type: "submit",
                                    disabled:
                                      !_vm.form.fecha_desde_rep ||
                                      !_vm.form.fecha_hasta_rep
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("arrow_downward")]),
                                  _vm._v(
                                    "\n                  Registrar\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.lista_reprogramaciones.length > 0
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.lista_reprogramaciones,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_desde
                                                          )
                                                          .format("DD/MM/YYYY")
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_hasta
                                                          )
                                                          .format("DD/MM/YYYY")
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(props.item.dias) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "error",
                                                        icon: "",
                                                        title: "Eliminar"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.eliminarReprogramacion(
                                                            props.item.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2907261217
                                    )
                                  }),
                                  _vm._v(
                                    "\n                Total días:" +
                                      _vm._s(_vm.sumatoria_dias_totales) +
                                      "\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("*")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n          "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "rgba(14, 187, 178, 0.35)",
                        type: "submit",
                        loading: _vm.loading,
                        disabled:
                          !_vm.form.motivo_reprogramacion ||
                          _vm.sumatoria_dias_totales != _vm.form.total_dias
                      },
                      on: { click: _vm.save }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v("REPROGRAMAR Y ENVIAR\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-706190c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-706190c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_uso/dialogs/ReprogramarCronograma.vue
// module id = null
// module chunks = 